import { useQuery } from '@tanstack/react-query';
import { getClient } from '../http/userApi';
import { getClientsArrQueryKey } from '@/utils/queryKeys';

export const useGetClientsArrQuery = (userTokens?: Array<string>) => {
  return useQuery({
    queryKey: getClientsArrQueryKey(),
    queryFn: async () => {
      const uniqueTokens = [...new Set(userTokens)];
      const responses = await Promise.all(
        uniqueTokens.map(async (token) => {
          const response = await getClient(token);
          return response.data;
        }),
      );
      return responses;
    },
  });
};
